import { render } from "./InformRmm.vue?vue&type=template&id=3dc82f1c&scoped=true"
import script from "./InformRmm.vue?vue&type=script&lang=js"
export * from "./InformRmm.vue?vue&type=script&lang=js"

import "./InformRmm.vue?vue&type=style&index=0&id=3dc82f1c&scoped=true&lang=css"

import exportComponent from "/tmp/build_6e4c079c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc82f1c"]])

export default __exports__